import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const FR: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 4H.5v15.998h24V4z' fill='#fff' />
        <path d='M8.502 4H.5v15.998h8.002V4z' fill='#0052B4' />
        <path d='M24.5 4h-8.002v15.998H24.5V4z' fill='#D80027' />
      </g>
      <path d='M.5 4h24v15.998H.5z' stroke='#111' />
    </svg>
  </i>
);

FR.displayName = 'FR';
export default FR;
